<template>
  <div class='hi'>
    Hi Vue!
  </div>
</template>

<script>
export default {
  data () {
    return { }
  }
}
</script>

<style>
  /*
.hi {
  color: red;
  font-size: 20px;

  font-style: italic;
}
*/
</style>
